export default "__VITE_ASSET__C57akn$9__"